import React from "react";
const Logo = () => {
  return (
    <div style={{
        height:"30px",
        objectFit:"contain",
        backgroundImage:'URL("./vEngageLogo.png")'
    }}>
        
    </div>
  );
};

export default Logo;
